/**
 * @generated SignedSource<<6a00a5feae43f46a755c493881fb60ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateEditChannelModalDeleteMutation$variables = {
  channelId: string;
};
export type CreateEditChannelModalDeleteMutation$data = {
  readonly deleteChannel: {
    readonly ok: boolean;
  } | null;
};
export type CreateEditChannelModalDeleteMutation = {
  response: CreateEditChannelModalDeleteMutation$data;
  variables: CreateEditChannelModalDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "channelId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "channelId",
        "variableName": "channelId"
      }
    ],
    "concreteType": "DeleteChannel",
    "kind": "LinkedField",
    "name": "deleteChannel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateEditChannelModalDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateEditChannelModalDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6242dc0ff04fd3d75fe34360d7a5b9e7",
    "id": null,
    "metadata": {},
    "name": "CreateEditChannelModalDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation CreateEditChannelModalDeleteMutation(\n  $channelId: ID!\n) {\n  deleteChannel(channelId: $channelId) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9e9baf95d07b9b38959673c4032f7ab";

export default node;
